<div class="container_width">
  <!-- Profile -->
  <div class="w-full flex flex-column gap-4">
    <div class="w-full flex-column md:flex-row flex align-items-start justify-content-between gap-2">
      <h1 class="text-left w-full md:w-auto font-bold text-4xl flex-shrink-0">Applicant Profile</h1>
      <div class="w-auto inline-flex flex-wrap align-items-center gap-2">
        <!-- <a pButton (click)="showAdditionalInformationDialog()" class="inline-flex gap-2 align-items-center linkTop"><i style="color: black;" class="pi pi-comment"></i><b style="color: black;">Assign Task</b></a> -->
        <a [routerLink]="['/mentor-portal','institute-search',userId]"
          class="inline-flex gap-2 align-items-center linkTop"><i class="pi pi-building"></i><b>Add College</b></a>
        <!-- <a class="inline-flex gap-2 align-items-center linkTop"><i class="pi pi-bell"></i><b>Send Notification</b></a> -->
        <a (click)="downloadProfileAsPDF()" class="inline-flex gap-2 align-items-center linkTop"><i
            class="pi pi-download"></i><b>Download Profile</b></a>
      </div>
    </div>
    <div class="w-full grid p-2 border-1 border-round-lg" style="border-color: #B1C2D9;">
      <div class="col-12 lg:col-7 flex-column lg:flex-row flex align-items-center gap-3">
        <div class="w-8rem h-8rem border-circle bg-blue-700 overflow-hidden flex-shrink-0">
          <img [src]="user?.imageUrl||'../../../assets/images/avatar1.jpg'" alt=""
            style="width: 100%; height: 100%; object-fit: cover; display: block;">
        </div>
        <div class="w-full flex flex-column gap-2">
          <h2 class="text-left font-medium text-2xl" style="color: #12263F;">{{(user?.firstName && user?.firstName !== 'null' ? user?.firstName : '') + (user?.lastName && user?.lastName !== 'null' ? ' ' + user?.lastName : '') || user?.email || 'Student'}}
          </h2>
          <div class="flex flex-wrap align-items-center gap-2">
            <span
              class="inline-flex align-items-center gap-2 py-2 px-3 text-sm bg-gray-100 text-gray-600 border-round-lg">
              D.O.B. : <span style="color: #111111;">{{user?.bornOn | date:'MMM dd/yyyy'}}</span></span>
            <span class="inline-block py-2 px-3 text-sm bg-gray-100 text-gray-600 border-round-lg">Application cycle :
              <span style="color: #111111;">{{user?.collageStartOn}}</span></span>
          </div>
          <!-- <div class="w-full flex align-items-center gap-3">
                    <i class="pi pi-user text-lg font-medium" style="color: #12263F;"></i>
                    <div class="flex flex-wrap align-items-center gap-2">
                      <span class="inline-block px-3 py-2 border-round-3xl"
                        style="background-color: #E6E5F3; color: #12263F;">{{genderDescriptions(user?.gender)}}</span>
                      <span class="inline-block px-3 py-2 border-round-3xl"
                        style="background-color: #E6E5F3; color: #12263F;">{{getCountryName(user?.homeCountry)}}</span>
                    </div>

                  </div> -->

          <div class="w-full pt-2 flex align-items-center flex-column md:flex-row gap-2">
            <div
              class="w-full sm:flex-1 flex flex-wrap align-items-center gap-1 border-round-lg py-2 pl-2 pr-3 text-gray-600"
              style="background-color: #F3F2FD;">
              <i class="pi pi-mars"></i>
              Gender :
              <span style="color: #12263F;">{{genderDescriptions(user?.gender)}}</span>
            </div>
            <div
              class="w-full sm:flex-1 flex flex-wrap align-items-center gap-1 border-round-lg  py-2 pl-2 pr-3 text-gray-600"
              style="background-color: #FBFBE2;">
              <i class="pi pi-map-marker"></i>
              Home Country :
              <span style="color: #12263F;">{{getCountryName(user?.homeCountry)}}</span>
            </div>

            <div
              class="w-full sm:flex-1 flex flex-wrap align-items-center gap-1 border-round-lg  py-2 pl-2 pr-3 text-gray-600"
              style="background-color: #FFF4EB;">
              <i class="pi pi-building"></i>
              City :
              <span style="color: #12263F;">{{user?.homeCity}}</span>
            </div>
          </div>

          <!-- new -->
          <div class="w-full pt-2 flex align-items-start flex-column md:flex-row gap-3">
            <div class="flex-1 flex align-items-start gap-2 text-gray-600">
              <div class="flex-shrink-0 border-circle flex align-items-center justify-content-center"
                style="height: 40px; width: 40px; background-color: #CED12A;">
                <i class="pi pi-map-marker" style="color: #111111;"></i>
              </div>
              <div class="w-full flex flex-column gap-1">
                <b class="font-normal text-sm text-gray-600">Intended Countries</b>
                <p style="color: #12263F;">{{user?.destination}}</p>
              </div>
            </div>
            <div class="flex-1 flex align-items-start gap-2 text-gray-600">
              <div class="flex-shrink-0 border-circle flex align-items-center justify-content-center"
                style="height: 40px; width: 40px; background-color: #CED12A;">
                <i class="pi pi-graduation-cap" style="color: #111111;"></i>
              </div>
              <div class="w-full flex flex-column gap-1">
                <b class="font-normal text-sm text-gray-600">Intended level</b>
                <p style="color: #12263F;">{{user?.degreePreference}}</p>
              </div>
            </div>

            <div class="flex-1 flex align-items-start gap-2 text-gray-600">
              <div class="flex-shrink-0 border-circle flex align-items-center justify-content-center"
                style="height: 40px; width: 40px; background-color: #CED12A;">
                <i class="pi pi-pencil" style="color: #111111;"></i>
              </div>
              <div class="w-full flex flex-column gap-1">
                <b class="font-normal text-sm text-gray-600">Intended major</b>
                <p style="color: #12263F;">{{user?.intendedMajor}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 lg:col-5 flex flex-column gap-3">
        <div class="w-full flex flex-column gap-2">
          <div class="w-full flex gap-2 pb-2 border-bottom-1" style="border-color: #D0D0DD;">
            <div *ngIf="user?.highSchoolName" class="flex-1 flex flex-column gap-1">
              <b class="font-normal text-gray-600 text-sm">High School Name</b>
              <p>{{user?.highSchoolName}}</p>
            </div>
            <div class="flex-1 flex flex-column gap-1">
              <b class="font-normal text-gray-600 text-sm">High School year of graduation</b>
              <p>{{user?.highSchoolEndDate | date: 'YYYY'}}</p>
            </div>
          </div>
          <div *ngIf="user?.underGraduateCollageName" class="w-full flex gap-2 pb-2 border-bottom-1"
            style="border-color: #D0D0DD;">
            <div class="flex-1 flex flex-column gap-1">
              <b class="font-normal text-gray-600 text-sm">Undergraduate School</b>
              <p>{{user?.underGraduateCollageName}}</p>
            </div>
            <div class="flex-1 flex flex-column gap-1">
              <b class="font-normal text-gray-600 text-sm">Undergraduate year of graduation</b>
              <p>{{user?.underGraduateEndDate | date: 'YYYY'}}</p>
            </div>
          </div>
          <div *ngIf="user?.graduateCollageName" class="w-full flex gap-2 pb-2 border-bottom-1"
            style="border-color: #D0D0DD;">
            <div class="flex-1 flex flex-column gap-1">
              <b class="font-normal text-gray-600 text-sm">Graduate School</b>
              <p>{{user?.graduateCollageName}}</p>
            </div>
            <div class="flex-1 flex flex-column gap-1">
              <b class="font-normal text-gray-600 text-sm">Graduate school year of graduation</b>
              <p>{{user?.graduateEndDate | date: 'YYYY'}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Tabs Section -->
    <div class="w-full">
      <p-tabView [(activeIndex)]="activeTab">
        <p-tabPanel header="Profile">
          <ng-template pTemplate="content">
            <div class="w-full flex flex-column gap-3 pt-2">
              <div class="w-full flex-column md:flex-row flex align-items-center gap-2 justify-content-between">
                <h2 class="text-left w-full md:w-auto font-bold text-2xl flex-shrink-0">{{currentProfileSection}}</h2>
                <div class="inline-flex align-items-center flex-wrap gap-3">
                  <a pButton (click)="showAdditionalInformationDialog()" class="inline-flex gap-2 align-items-center linkTop"><i
                      style="color: black;" class="pi pi-comment"></i><b style="color: black;">Assign Task</b></a>

                  <div class="inline-flex align-items-center flex-wrap">
                    <a [ngClass]="{'active': currentProfileSection == profileSection.Profile}"
                      class="w-auto text-sm border-1 links cursor-pointer"
                      (click)="openSection(profileSection.Profile)">Profile</a>
                    <a [ngClass]="{'active': currentProfileSection == profileSection.EssayPilot}"
                      class="w-auto text-sm border-1 links cursor-pointer"
                      (click)="openSection(profileSection.EssayPilot)">Essay Pilot</a>
                    <a [ngClass]="{'active': currentProfileSection == profileSection.CheckList}"
                      class="w-auto text-sm border-1 links cursor-pointer"
                      (click)="openSection(profileSection.CheckList)">Checklist</a>
                    <a [ngClass]="{'active': currentProfileSection == profileSection.General}"
                      class="w-auto text-sm border-1 links cursor-pointer" (click)="openSection(profileSection.General)">General
                      Tasks</a>
                    <a [ngClass]="{'active': currentProfileSection == profileSection.Colleges}"
                      class="w-auto text-sm border-1 links cursor-pointer" (click)="openSection(profileSection.Colleges)">Application</a>
                  </div>
                </div>
              </div>

              <!-- Component Goes Here -->
              <app-profile-section *ngIf="currentProfileSection == profileSection.Profile"></app-profile-section>
              <app-essay-pilot-section *ngIf="currentProfileSection == profileSection.EssayPilot"></app-essay-pilot-section>
              <app-check-list-section *ngIf="currentProfileSection == profileSection.CheckList"></app-check-list-section>
              <app-general-tasks *ngIf="currentProfileSection == profileSection.General"></app-general-tasks>
              <app-colleges-section *ngIf="currentProfileSection == profileSection.Colleges"></app-colleges-section>
              <!-- Component Goes Here -->
            </div>
          </ng-template>
        </p-tabPanel>
        
        <p-tabPanel header="Document Vault">
          <ng-template pTemplate="content">
            <div class="w-full pt-2">
              <app-operations-student-document-vault [isMentorView]="true" [studentId]="userId"></app-operations-student-document-vault>
            </div>
          </ng-template>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>

</div>

<!-- <p-dialog header="Task" [modal]="true" [(visible)]="addClgVisible" [style]="{ width: '40rem' }">
  <h1>COLLEGES</h1>
</p-dialog> -->

<!-- <p-button (onClick)="showDialog()" label="Show" /> -->
<p-dialog header="Task" [modal]="true" [(visible)]="visible" [style]="{ width: '40rem' }" (onHide)="onDialogClose()">

  <div class="flex flex-column align-items-center gap-2 mb-4">
    <div class="w-full flex align-items-center justify-content-between">
      <b class="font-normal">Add Task</b>
      <p-button label={{currentProfileSection}} styleClass="pop_btn" />
    </div>
    <form class="w-full" [formGroup]="additionalInformationForm" (ngSubmit)="onAdditionalInformaionSubmit()">
      <div class="w-full mb-2 flex flex-column gap-2 ">
        <label for="startDate">Start Date and Time</label>
        <p-calendar inputId="startDate" appendTo="body" formControlName="startDate" [showTime]="true"
          [style]="{ width: '100%' }" [inputStyle]="{ width: '100%' }" [hourFormat]="'12'" />
        <small class="text-red-500 block" *ngIf="additionalInformationForm.get('startDate')?.invalid &&
               (submitted || additionalInformationForm.get('startDate')?.touched)">
          Start Date and Time is required
        </small>
      </div>
      <div class="w-full mb-2 flex flex-column gap-2 ">
        <label for="dueDate">End Date and Time</label>
        <p-calendar inputId="dueDate" appendTo="body" formControlName="dueDate" [showTime]="true"
          [style]="{ width: '100%' }" [inputStyle]="{ width: '100%' }" [hourFormat]="'12'" />
        <small class="text-red-500 block" *ngIf="additionalInformationForm.get('dueDate')?.invalid &&
               (submitted || additionalInformationForm.get('dueDate')?.touched)">
          End Date and Time is required
        </small>
      </div>

      <div class="flex flex-column gap-3">
        <textarea class="w-full"
          style="border: 1px solid #CCD7E7; border-radius: 4px; padding: 8px; box-sizing: border-box;" rows="5"
          cols="30" pInputTextarea formControlName="additionalInfo">
            </textarea>
        <small class="text-red-500 block" *ngIf="additionalInformationForm.get('additionalInfo')?.invalid &&
                        (submitted || additionalInformationForm.get('additionalInfo')?.touched)">
          Information is required
        </small>
        <div class="flex flex-column gap-2">
          <label class="font-medium text-sm">Choose Priority Color</label>
          <div class="flex flex-wrap gap-3 mt-1">
            <div *ngFor="let color of brandColors"
                 (click)="onColorSelect(color)"
                 [style.background-color]="color"
                 class="w-2rem h-2rem border-circle cursor-pointer transition-all transition-duration-200 hover:scale-110 shadow-1"
                 [style.border]="selectedColor === color ? '3px solid #fff' : '1px solid #dee2e6'"
                 [style.outline]="selectedColor === color ? '2px solid ' + color : 'none'"
                 [title]="color">
            </div>
          </div>
          <small class="text-gray-500 text-xs">Selected color will be used for task identification.</small>
        </div>
        <div class="flex align-items-center gap-2 ">
          <p-fileUpload styleClass="fileupload" #fileUploader mode="basic" name="demo[]" chooseIcon="pi pi-upload"
            url="https://www.primefaces.org/cdn/api/upload.php" accept=".pdf,.doc,.docx,image/*" maxFileSize="1000000"
            fileLimit="1" (onSelect)="onFileSelect($event)" [auto]="false" chooseLabel="Browse"
            (filesRemoved)="onFileRemoved()" />
          <p-button *ngIf="attachment" class="font-regular" (onClick)="onFileRemoved()" icon="pi pi-times"
            styleClass="closeIcon" [rounded]="true" appendTo="body" pTooltip="Clear image" tooltipPosition="top" />
          <!-- <ng-container *ngIf="uploadedImageUrl">
                  <div class="image-thumbnail-container" tabindex="0">
                    <img
                      [src]="uploadedImageUrl"
                      alt="Uploaded"
                      class="image-thumbnail"
                    />
                    <div class="image-preview">
                      <img
                        [src]="uploadedImageUrl"
                        alt="Large Preview"
                        class="image-large"
                      />
                    </div>
                  </div>
                </ng-container> -->
        </div>
        <p-button label="Submit" [loading]="isLoading" class="mt-3" styleClass="save_btn1" type="submit" />
      </div>

    </form>
  </div>

  <!-- <div class="flex flex-column align-items-center gap-2 p-3 border-round-lg" style="background-color: #EDF2F9;">
      <b class="w-full text-left text-lg font-medium" style="color: #000;">Recent</b>
      <div class="w-full p-3 flex flex-column gap-3 border-round-xl bg-white" >
        <div class="w-full pr-6">
            <div class="w-full flex align-items-start gap-2">
                <div class="border-circle overflow-hidden flex-shrink-0" style="height: 36px; width: 36px;">
                    <img src="../../../assets/images/muskaan.jpg" alt="" style="width: 100%; height: 100%; object-fit: cover; display: block;">
                </div>
                <div class="w-full flex flex-column gap-1">
                    <div class="w-full p-2" style="background-color: #F3F3F3; border-radius: 0 8px 8px 8px;">
                        <p class="text-left font-normal text-sm" style="color: #303030;">{{recentResolvedQuestion?.question??'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.'}}</p>
                    </div>
                    <p class="text-left font-normal text-xs" style="color: #808080;">{{recentResolvedQuestion?.createdOn??'Date : 07-FEB-2025' | date: 'MMM dd/yyyy'}}</p>
                </div>
            </div>
        </div>
        <div class="w-full pl-6">
          <div class="w-full flex align-items-start gap-2">
              <div class="w-full flex flex-column gap-1">
                  <div class="w-full flex flex-column gap-1 p-2" style="background-color: #FAFAD8; border-radius: 8px 0 8px 8px;">
                    <b class="w-full block text-right font-medium text-base" style="color: #101010; text-align: right;">Jonathan Smith</b>
                    <p class="text-right font-normal text-sm" style="color: #303030;">{{recentResolvedQuestion?.reply??'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.'}}</p>
                  </div>
                  <p class="text-right font-normal text-xs" style="color: #808080;">{{recentResolvedQuestion?.updatedOn??'Date : 07-FEB-2025' | date: 'MMM dd/yyyy' }}</p>
              </div>
              <div class="border-circle overflow-hidden flex-shrink-0" style="height: 36px; width: 36px;">
                <img src="../../../assets/images/muskaan.jpg" alt="" style="width: 100%; height: 100%; object-fit: cover; display: block;">
            </div>
          </div>
        </div>
    </div>
    </div> -->

</p-dialog>
